import React from "react";

/**
 * InfoRow — issue #750 § 5.12. An icon + muted text line in a bordered
 * white box — the small factual asides (e.g. "Grounds without coordinates
 * aren't supported yet") that sit under a field or a card.
 *
 * `EmptyRecord.dc.html:74,79` draws this top-aligned (`align-items:
 * flex-start`, the icon nudged down `margin-top: 2px`) because the text is
 * two or three lines by design — a centred icon floats to the middle of a
 * wrapped paragraph instead of sitting with its first line.
 */
export function InfoRow({ icon = null, children, className = "", "data-testid": testId, ...rest }) {
  return (
    <div
      data-testid={testId}
      className={`flex items-start ${className}`}
      style={{
        gap: 8,
        background: "var(--nw-surface)",
        borderRadius: "var(--nw-radius-control)",
        border: "1px solid var(--nw-line)",
        padding: "12px 14px",
      }}
      {...rest}
    >
      {icon && (
        <span
          aria-hidden="true"
          className="flex items-center justify-center"
          style={{ width: 16, height: 16, marginTop: 2, color: "var(--nw-ink-muted)", flexShrink: 0 }}
        >
          {icon}
        </span>
      )}
      <span className="nw-help">{children}</span>
    </div>
  );
}

export default InfoRow;
